import { DelegateRequestFields } from '@ms/yammer-graphql';

import { DelegationRequest } from '../../../state/delegationRequests/types';

export const processDelegationRequest: (value: DelegateRequestFields) => DelegationRequest = (value) => ({
  id: value.delegateRequestId,
  state: value.state,
  delegateRole: value.delegateRole,
  canPostToStoryline: value.canPostToStoryline,
  requestType: value.requestType,
  createdAt: value.createdAt,
  delegateTeamOwnerId: value.delegateTeamOwner.id,
  requestedDelegateUserId: value.requestedDelegate.id,
});
